/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const WalletAwardsSection = dynamic(() => import('./WalletAwardsSection').then(mod => mod.WalletAwardsSection));

export const WalletAwardsSectionConfig = {
  emptyLabel: 'walletawardssection',
  isEmpty: () => false,
  resourceType: `mi-aem-account/components/content/walletawardssection`,
};

export const WalletAwardsSectionEditable = (props: any) => (
  <EditableComponent config={WalletAwardsSectionConfig} {...props}>
    <WalletAwardsSection {...props} />
  </EditableComponent>
);

export type { WalletAwardsSectionProps, WalletAwardsSectionModel } from './types';
export { WalletAwardsSection };
